import type { NavItem } from '../types/navItem'
import { NavItemAccessor } from '../types/navItemAccessor'
import type { NavItemSeparator } from '../types/navItemSeparator'

const isSeparator = (item: { accessor?: NavItemAccessor } | undefined): boolean =>
  item?.accessor === NavItemAccessor.Separator

/**
 * Removes leading, trailing, and consecutive separators from a NavItem list.
 * Use after filtering a list that already contains separators (e.g. from
 * `joinNavItemGroups`), since removing items can leave separators stranded.
 */
export const sanitizeNavItemSeparators = <T>(items: NavItem<T | NavItemSeparator>[]): NavItem<T | NavItemSeparator>[] =>
  items.filter((item, index, allItems) => {
    if (!isSeparator(item)) {
      return true
    }

    const previousItem = allItems[index - 1]
    const hasPreviousRealItem = previousItem !== undefined && !isSeparator(previousItem)
    const hasLaterRealItem = allItems.slice(index + 1).some((laterItem) => !isSeparator(laterItem))

    return hasPreviousRealItem && hasLaterRealItem
  })
